import { render } from "./ChatActionModal.vue?vue&type=template&id=c257e3d8&scoped=true"
import script from "./ChatActionModal.vue?vue&type=script&lang=js"
export * from "./ChatActionModal.vue?vue&type=script&lang=js"

import "./ChatActionModal.vue?vue&type=style&index=0&id=c257e3d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c257e3d8"]])

export default __exports__